import(/* webpackMode: "eager" */ "/app/app/(app)/shop/store-list/page.tsx");
